module.exports = __webpack_public_path__ + "img/aston-martin.ff1f9b7d.webp";